import _styled from"@emotion/styled";import*as React from"react";import{css}from"@emotion/react";import{SubscriptionPlan}from"@wp/src/common/api/SubscriptionApi";import{Button,FlexLayout,mediaQuery}from"@wp/src/components/common";import{Caption400Neutral500}from"@wp/src/components/common/atoms";import urlProvider from"@wp/src/common/utils/urlProvider";import{isGoldPlan,isPlatinumPlan}from"@wp/src/components/common/subscriptionFramework/helpers";export const PlanCardContainer=_styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  box-shadow: 0 4px 8px 0 rgba(15, 23, 42, 0.16);
  flex: 1;
  ${props=>mediaQuery({flexBasis:props.subscriptionPlan===SubscriptionPlan.Free?["100%","100%","100%","30%","28%","23%"]:["100%","100%","100%","31%","32%","33%"],maxWidth:props.subscriptionPlan===SubscriptionPlan.Free?["initial","initial","initial","300px"]:["initial","initial","initial","420px"]})}
  & > div,
    & > button {
    margin-bottom: 16px;
  }
  ${props=>props.isDisabledPlan?"":css`
          & > div:last-child,
          & > button:last-child {
            margin-top: auto;

            margin-bottom: 0;
          }
        `}
  border-radius: 16px;
  padding: 16px;
  background: ${props=>isGoldPlan(props.subscriptionPlan)?props.theme.colors.amber100:isPlatinumPlan(props.subscriptionPlan)?props.theme.colors.neutral100:props.theme.colors.white};

  ${props=>props.subscriptionPlan===SubscriptionPlan.Free&&`border: 1px solid ${props.theme.colors.neutral300};`}
`;export const StyledPlanButton=_styled(Button)`
  ${props=>isGoldPlan(props.subscriptionPlan)?css`
          background: ${props.theme.colors.amber500};
          border-color: ${props.theme.colors.amber500};
          color: ${props.theme.colors.white};

          &:not([disabled]) {
            &:hover,
            &:active {
              background: ${props.theme.colors.amber600} !important;
              border-color: ${props.theme.colors.amber600} !important;
              color: ${props.theme.colors.white} !important;
            }
          }
        `:""}
`;export const StyledPlanTitle=_styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 30px;
  color: ${props=>isGoldPlan(props.subscriptionPlan)?props.theme.colors.amber900:props.theme.colors.neutral900};
`;export const StyledPlanDescription=_styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${props=>isGoldPlan(props.subscriptionPlan)?props.theme.colors.amber600:isPlatinumPlan(props.subscriptionPlan)?props.theme.colors.neutral600:props.theme.colors.neutral500};
`;export const BenefitsContainer=_styled.div`
  color: ${props=>isGoldPlan(props.subscriptionPlan)?props.theme.colors.amber900:props.theme.colors.neutral500};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  ul {
    font-size: 12px;
    margin: 4px 0;
    li {
      margin-bottom: 2px;
    }
  }
`;export const CollapseContainer=_styled.div`
  padding: 12px;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${props=>props.theme.colors.neutral300};
  cursor: pointer;
`;export const StyledText=_styled.div`
  ${props=>props.isVerticalText?"writing-mode: vertical-rl; transform: rotate(180deg);":""}
  font-size: 16px;
  color: ${props=>props.theme.colors.neutral600};
  font-weight: 500;
`;export const YouAreSubscribedButton=_styled(FlexLayout)`
  font-weight: 500;
  height: 40px;
  ${mediaQuery({fontSize:["16px","16px","16px","20px"]})}
  color: ${props=>isGoldPlan(props.subscriptionPlan)?props.theme.colors.amber600:isPlatinumPlan(props.subscriptionPlan)||props.subscriptionPlan===SubscriptionPlan.Free?props.theme.colors.neutral600:props.theme.colors.black};
`;export const StrikeThrough=_styled.span`
  text-decoration: line-through;
  margin-right: 8px;
`;export const StyledTrialOverPriceDetailsContainer=_styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  padding: 8px;
  border-radius: 8px;
  text-align: center;
  background: ${props=>props.theme.colors.green50};
  width: 100%;
  color: ${props=>props.theme.colors.green600};
`;export const CancelOrDowngradeText=()=>React.createElement(Caption400Neutral500,null,"You can cancel or downgrade at any time."," ",React.createElement("a",{href:urlProvider.disclosures,target:"_blank",rel:"noreferrer"},"View disclosures and compliance documents"));